/** Extract a display handle from a social profile URL (e.g. @bcsabha). */
export function socialHandleFromUrl(url) {
  if (!url?.trim()) return "";
  try {
    const parsed = new URL(url.startsWith("http") ? url : `https://${url}`);
    const segment = parsed.pathname.split("/").filter(Boolean).pop();
    if (!segment) return parsed.hostname.replace(/^www\./, "");
    return segment.startsWith("@") ? segment : `@${segment}`;
  } catch {
    return url.trim();
  }
}

export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "youtube", label: "YouTube" },
];
